import React from 'react';
import BlockRenderer from '../../components/composer/BlockRenderer';
import Page from '../../components/Page';
import { ComposerPageProps } from '../../types/composer';
import Metadata from '../Metadata';
import SkipLink from '../SkipLink';
import { ComposerBlocksProvider } from './BlockContext';

export type Props = {
  page: ComposerPageProps;
};

/**
 * Composer page route.
 */
const ComposerPage = (props: Props) => {
  const { page, ...rest } = props;
  const url = new URL(page?.url, 'https://www.osmosis.org');

  return (
    <Page headerSearchVisible={false} {...rest}>
      <Metadata
        title={page?.data?.title}
        descr={page?.data?.description}
        url={url.href}
        type="website"
      />
      <SkipLink
        linkText="main content"
        linkUrl={['h1-main-content', 'h2-sub-content']}
      />
      <ComposerBlocksProvider>
        <BlockRenderer page={page} />
      </ComposerBlocksProvider>
    </Page>
  );
};

export default ComposerPage;
